<template>
  <div class="checkout-view">
    <b-container>
      <section class="section section--loader" v-if="searching">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section" v-else>
        <b-row>
          <b-col md="12" xl="9">
            <checkout-content-block :solution="selected_solution" />
          </b-col>
          <b-col md="12" xl="3">
            <sidebar
              :validate_on_mount="validate_on_mount"
              :integration="integration"
              :availability="get_availability()"
              :live_price="live_price"
              :loading="loading"
              :purchasing="purchasing"
              :completed="completed"
              :discount_codes="discount_codes"
              @purchase="sidebar_data => { book(sidebar_data) }"
              @commit="event => { this.$store.commit(event.name, event.payload) }"
            >
              <!--slot riepilogo ordine-->
              <template #resume>
                <resume
                  class="checkout-view__resume"
                  v-if="Object.keys(selected_solution.property).length"
                  :property_data="selected_solution.property"
                />
              </template>

              <!--slot messaggi di stato-->
              <template #message>
                <!--acquisto completato-->
                <div v-if="completed" class="vb-sidebar__block">
                  <div v-if="success" v-html="'Acquisto completato con successo'" />
                  <div v-else v-html="'C\'è stato un problema.'" />
                </div>
                <!--acquisto in corso-->
                <div v-if="!completed && purchasing" class="text-center">
                  <loader>
                    <template>
                      <span>Prenotazione in corso... non abbandonare o ricaricare la pagina!</span>
                    </template>
                  </loader>
                </div>
              </template>

              <!--slot libero prima del pulsante di acquisto-->
              <template #before_purchase>
                <p class="text-left mb-0">
                  Se procedi alla prenotazione dichiari di accettare la <a href="https://www.booking.com/content/privacy.it.html" target="_blank">Privacy policy</a>
                  e le <a href="https://www.booking.com/content/terms.it.html" target="_blank">Condizioni d'uso</a> di <span class="text-primary">Booking.com</span>
                </p>
              </template>
            </sidebar>
          </b-col>
        </b-row>
      </section>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { number, format } from 'mathjs'
import { service_handler } from '@src/services'
import { custom_event, get_config } from "@src/utilities"
import CheckoutContentBlock from '@liveeps/components/views/content-blocks/checkout'
import Resume from '@liveeps/components/blocks/resume/resume'

export default {
  name: 'checkout-view',

  components: {
    'checkout-content-block': CheckoutContentBlock,
    'resume': Resume,
  },

  props: {
  },

  data() {
    return {
      integration: this.$config.integration,
      loading: false,                         // caricamento dati
      purchasing: false,                      // sidebar completata -> acquisto in corso
      completed: false,                       // acquisto completato
      success: false,                         // esito della purchase() -> cambia il messaggio mostrato all'utente
      validate_on_mount: true,
      message: '',
      live_price: '0',
    }
  },

  computed: {
    ...mapState({
      // stato globale
      searching: state => state.searching,
      discount_codes: state => state.discount_codes,

      // stato del modulo liveeps
      selected_solution: state => state.liveeps.selected_solution,
    }),

    ecommerce_data() {
      return {
        currency: "EUR",
        items: this.parseGa4EcommerceItems(this.selected_solution.property),
        value: format(number(this.selected_solution.property.rate.pricing.total), {notation: 'fixed', precision: 2}),
      }
    }
  },

  created() {
  },

  mounted() {
    this.live_price = this.selected_solution.property.live_price
    custom_event({ event: 'begin_checkout', ecommerce: this.ecommerce_data })
    custom_event({ event: 'add_to_cart', ecommerce: this.ecommerce_data })
  },

  methods: {

    // Chiamata alla book
    book(sidebar_data) {

      let book = {
        bookingData: {
          checkin: this.selected_solution.dates.checkin,
          checkout: this.selected_solution.dates.checkout,
          occupancy: this.selected_solution.dates.occupancy,
          payments: sidebar_data.payments,
          booker_email: sidebar_data.guest.payload.guestEmail,
          booker_telephone: sidebar_data.guest.payload.guestPhone,
          property_id: this.selected_solution.property.details.property_id,
          room_id: this.selected_solution.property.room.id,
          rate_id: this.selected_solution.property.rate.id,
          bed_group_id: this.selected_solution.property.bed_type.id,
          bed_group_token: this.selected_solution.property.bed_type.token,
          live_price: this.live_price,
          solution: this.selected_solution,
        },
        guestFirstName: sidebar_data.guest.payload.guestFirstName,
        guestLastName: sidebar_data.guest.payload.guestLastName,
        guestFiscalCode: sidebar_data.guest.payload.guestFiscalCode,
        guestEmail: sidebar_data.guest.payload.guestEmail,
        guestEmailConf: sidebar_data.guest.payload.guestEmailConf,
        guestPhone: sidebar_data.guest.payload.guestPhone,
        guestPrivacy: sidebar_data.guest.payload.guestPrivacy,
        guestGdpr: sidebar_data.guest.payload.guestGdpr
      }

      if (sidebar_data.guest.payload.beneficiaryId) book.beneficiaryId = sidebar_data.guest.payload.beneficiaryId

      if (sidebar_data.booker.payload !== false) {
        book.guestAddress = sidebar_data.booker.payload.booker_address
        book.guestCity = sidebar_data.booker.payload.booker_city
      }

      if (sidebar_data.bill_to_pax.payload !== false) {
        book.guestAddress = sidebar_data.bill_to_pax.payload.guestAddress
        book.guestCity = sidebar_data.bill_to_pax.payload.guestCity
        book.guestPostalCode = sidebar_data.bill_to_pax.payload.guestPostalCode
        book.guestProvince = sidebar_data.bill_to_pax.payload.guestProvince
        book.guestFiscalCode = sidebar_data.bill_to_pax.payload.guestFiscalCode
      }
      
      this.purchasing = true
      this.success = false
      window.scrollTo(0,0)

      service_handler(
        'book',
        book,
      ).then(
        (success) => {
          this.success = true
          this.purchasing = false
          this.completed = true
          window.scrollTo(0,0) // la sidebar sparisce quasi per intero => riporto lo scroll della pagina in alto

          custom_event('confirmedCheckout', get_config('integration.company'), success.data.live_price, 'partnerBehaviour')
          if(success.data.boughtProductTypes){
            success.data.boughtProductTypes.forEach(productType => {
              custom_event('book', productType, success.data.live_price, 'productType')
            })
          }

          custom_event({
            event: 'purchase',
            ecommerce: { ...this.ecommerce_data, transaction_id: success.data.confirmcode }
          })
          
          // da valutare: a prenotazione completata cancello i dati necessari al checkout ( => per un'altra prenotazione bisogna ripassare per la ricerca)
          //this.$store.commit('liveeps/selected_solution', {})

          window.location.href = '/confirm/' + success.data.confirmcode + '/' + success.data.itinerary_id.toString()
        },
        (error) => {
          this.log('[book] - error')
          this.log(error.response)
          this.validate_on_mount = true
          this.success = false
          this.purchasing = false
          custom_event('failedCheckout', get_config('integration.company'), book.bookingData.live_price, 'partnerBehaviour')
        }
      )
    },

    parseGa4EcommerceItems(property){
      return {
        item_id: property.room.id + "-" + property.rate.id,
        item_name: property.room.name + " - " + property.rate.id,
        price: format(number(property.rate.pricing.total), {notation: 'fixed', precision: 2})
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>